// extracted by mini-css-extract-plugin
export default {"title":"PickupForm_title__9FW4x","image":"PickupForm_image__QxamS"};